// For Local Development
//const HomeURL = "http://localhost:53183/";
// For Production 
//const HomeURL = "https://admincredence.gagriglobal.com/webservices/"; //gagri local credentials
const HomeURL = "https://admin.credencediagnostics.com/webservices/"; //public credentials

export { HomeURL };
